import React from 'react';
import { NavLink } from 'react-router-dom';

import Logout from '@common/react/components/UI/Logout/Logout';

import styles from '@app/components/UI/Header/MenuPHJ/MenuPHJ.module.scss';
import AngleDownSVG from '@app/images/icons/AngleDownSVG';
import { CustomMenuItem } from '@app/objects/CustomMenuItem';
import { AppRoute } from '@app/utils/appRoutes';

const menuAuthorized: Array<CustomMenuItem> = [
	{
		path: AppRoute.USING_PHJ,
		name: 'Using Pet Hospice Journal',
	},
	{
		path: AppRoute.ABOUT,
		name: 'About the Journal',
	},
	{
		path: '#',
		name: 'Contact PHJ Support',
		modal: 'contact-form',
	},
	{
		path: AppRoute.PETS,
		name: 'My Pets',
	},
	{
		path: AppRoute.PROFILE,
		name: 'Owner Profile',
	},
	{
		name: (
			<Logout
				clearState
				render={(logout) => (
					<a
						className={styles.logoutComponent}
						onClick={(e) => {
							logout(e);
						}}
					>
						Sign out
					</a>
				)}
			/>
		),
	},
];

const menuUnauthorized: Array<CustomMenuItem> = [
	{
		path: AppRoute.USING_PHJ,
		name: 'Using Pet Hospice Journal',
	},
	{
		path: AppRoute.ABOUT,
		name: 'About the Journal',
	},
	{
		path: '#',
		name: 'Contact PHJ Support',
		modal: 'contact-form',
	},
	{
		name: (
			<NavLink className="btn btn-primary" to={AppRoute.CREATE_PROFILE}>
				Begin
			</NavLink>
		),
	},
	{
		name: (
			<button className="btn btn-primary">
				Sign in
			</button>
		),
		modal: 'sign-in',
	},
];

export const menuAuthorizedPHJ: Array<CustomMenuItem> = [
	{
		name: (
			<button className={`btn btn-purple-gray ${styles.btnCarrot}`}>
				<AngleDownSVG />
			</button>
		),
		children: [menuAuthorized],
	},
];

export const menuUnauthorizedPHJ: Array<CustomMenuItem> = [
	{
		name: (
			<button className={`btn btn-purple-gray ${styles.btnCarrot}`}>
				<AngleDownSVG />
			</button>
		),
		children: [menuUnauthorized],
	},
];
